<template>
    <v-main class="mt-n13" v-resize="onResize">
        <v-container xs="12" class="px-sm-3 mb-n7" fluid>
            <v-row class="fill-height">
                <v-col>
                    <v-sheet height="64">
                        <v-toolbar flat color="white">
                            <v-btn outlined class="mr-4" color="grey darken-2" @click="setToday">
                                오늘
                            </v-btn>
                            <v-btn fab text small color="grey darken-2" @click="prev">
                                <v-icon small>mdi-chevron-left</v-icon>
                            </v-btn>
                            <v-btn fab text small color="grey darken-2" @click="next">
                                <v-icon small>mdi-chevron-right</v-icon>
                            </v-btn>
                            <v-toolbar-title v-if="$refs.calendar">
                                {{ $refs.calendar.title }}
                            </v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-btn outlined class="mr-4 d-none d-md-flex" color="grey darken-2" @click="calendarHeight += heightStep">
                                달력높이 <v-icon>mdi-arrow-up-bold</v-icon>
                            </v-btn>
                            <v-btn outlined class="mr-4 d-none d-md-flex" color="grey darken-2" @click="calendarHeight -= heightStep">
                                달력높이 <v-icon>mdi-arrow-down-bold</v-icon>
                            </v-btn>
                            <div class="d-none d-md-flex">
                                <v-menu bottom right>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                                outlined
                                                color="grey darken-2"
                                                v-bind="attrs"
                                                v-on="on"
                                        >
                                            <span>{{ typeToLabel[type] }}</span>
                                            <v-icon right>mdi-menu-down</v-icon>
                                        </v-btn>
                                    </template>
                                    <v-list>
                                        <v-list-item @click="type = 'month'">
                                            <v-list-item-title>월별보기</v-list-item-title>
                                        </v-list-item>
                                        <v-list-item @click="type = 'week'">
                                            <v-list-item-title>주별보기</v-list-item-title>
                                        </v-list-item>
                                        <v-list-item @click="type = 'day'">
                                            <v-list-item-title>일별보기</v-list-item-title>
                                        </v-list-item>
                                    </v-list>
                                </v-menu>
                            </div>
                        </v-toolbar>
                    </v-sheet>
                    <v-sheet :height="calendarHeight">
                        <v-calendar
                                ref="calendar"
                                v-model="focus"
                                :color="groupSetting.mainColor"
                                :events="events"
                                :event-color="getEventColor"
                                :type="type"
                                @click:event="showEvent"
                                @click:more="viewDay"
                                @click:date="viewDay"
                                @change="updateRange"
                        ></v-calendar>
                        <v-menu
                                v-model="selectedOpen"
                                :close-on-content-click="false"
                                :activator="selectedElement"
                                offset-x
                        >
                            <v-card
                                    color="grey lighten-4"
                                    min-width="350px"
                                    flat
                            >
                                <v-toolbar
                                        :color="selectedEvent.color"
                                        dark
                                >
                                    <v-btn icon>
                                        <v-icon>mdi-tree</v-icon>
                                    </v-btn>
                                    <v-toolbar-title v-html="selectedEvent.name" class="ml-n6"></v-toolbar-title>

                                </v-toolbar>
                                <v-card-text>
                                    <span v-html="selectedEvent.details" @click="copyToClipboard"></span>
                                </v-card-text>
                                <v-card-actions>
                                    <v-btn
                                            text
                                            color="secondary"
                                            @click="selectedOpen = false"
                                    >
                                        닫기
                                    </v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-menu>
                    </v-sheet>
                </v-col>
            </v-row>
        </v-container>
    </v-main>
</template>

<script>
import axios from "axios";

export default {
    data: () => ({
        calendarHeight: 800,
        heightStep: 100,
        focus: '',
        type: 'month',
        typeToLabel: {
            month: '월별보기',
            week: '주별보기',
            day: '일별보기'
        },
        selectedEvent: {},
        selectedElement: null,
        selectedOpen: false,
        events: [],
        colors: ['blue', 'indigo', 'deep-purple', 'cyan', 'green', 'orange', 'grey darken-1'],
        names: ['Meeting', 'Holiday', 'PTO', 'Travel', 'Event', 'Birthday', 'Conference', 'Party'],
        groupSetting : {}
    }),
    mounted () {
        this.$refs.calendar.checkChange()
        this.onResize()
    },
    created: function(){

        this.groupSetting = this.$store.getters.getGroupSetting

        const y = new Date().getFullYear()
        let m = new Date().getMonth() + 1

        if(m < 10){
            m = '0' + m
        }

        this.getCalendarItems(y + "" + m)

    },
    methods: {
        viewDay ({ date }) {
            this.focus = date
            this.type = 'day'
        },
        getEventColor (event) {
            return event.color
        },
        setToday () {
            this.focus = ''
        },
        prev () {
            this.$refs.calendar.prev()
        },
        next () {
            this.$refs.calendar.next()
        },
        showEvent ({ nativeEvent, event }) {
            const open = () => {
                this.selectedEvent = event
                this.selectedElement = nativeEvent.target
                setTimeout(() => this.selectedOpen = true, 10)
            }

            if (this.selectedOpen) {
                this.selectedOpen = false
                setTimeout(open, 10)
            } else {
                open()
            }

            nativeEvent.stopPropagation()
        },
        updateRange () {
            // console.log(this.$refs.calendar.next())
            // this.getCalendarItems(yearMonth)
        },
        getCalendarItems(yearMonth) {

            if(!yearMonth){
                alert('년월 정보가 없습니다.')
                return false
            }

            // const mainColor = this.groupSetting.mainColor

            return axios({
                method: 'GET',
                headers: {
                    'Authorization': 'bearer ' + this.$store.getters.getAccessToken
                },
                url: this.$store.getters.getApiUrl + '/api/v1/order/getCalendarItems/' + yearMonth,
                timeout: this.$store.getters.getApiRequestTimeLimit
            })
            .then((response, groupSetting = this.groupSetting) => {

                const data = response.data

                if(data && data.length > 0) {

                    const events = []

                    data.forEach(function(item){

                        const targetDate = new Date(item.dueDate.substr(0,10))
                        targetDate.setDate(targetDate.getDate() + 1) //todo 현재 - 1일씩 더해줌.. 왜 response.data가 -1일이 되어있지?;; 확인 필요

                        let details = "<div class='copyThis'>";

                        if(item.method1 != '' && item.method1 != null){
                            details += '(' + item.method1 + ') '
                        }

                        if(item.address1 != '' && item.address1 != null){
                            details += '배송지1 : ' + item.address1
                        }

                        if(item.phone1 != '' && item.phone1 != null){
                            details += ' / ' + item.phone1 + '<br />'
                        }

                        if(item.method2 != '' && item.method2 != null){
                            details += '(' + item.method2 + ') '
                        }

                        if(item.address2 != '' && item.address2 != null){
                            details += '배송지2 : ' + item.address2
                        }

                        if(item.phone2 != '' && item.phone2 != null){
                            details += ' / ' + item.phone2 + '<br />'
                        }

                        details += "</div>"

                        if(item.comment){
                            details += '-----------------------------------------<br />비고 : ' + item.comment
                        }

                        events.push({
                            name: item.title,
                            details: details,
                            start: targetDate,
                            color: groupSetting.mainColor,
                        })

                    })

                    this.events = events

                }

            })

        },
        copyToClipboard: function() {

            document.querySelector(".copyThis").addEventListener("click", function(){
                let tempElem = document.createElement('textarea')
                tempElem.value = document.getElementsByClassName('copyThis').item(0).textContent
                document.body.appendChild(tempElem)

                tempElem.select()
                document.execCommand("copy")
                document.body.removeChild(tempElem)
            })

        },
        onResize: function() {

            switch(this.$vuetify.breakpoint.name) {
                case 'xs':
                case 'sm':
                    this.type = 'day'
                    break
                case 'md':
                case 'lg':
                case 'xl':
                    this.type = 'month'
                    break
                default:
                    this.type = 'month'
            }

        }

    },
    beforeCreate: async function() {

        if(!this.$store.getters.getAccessToken){
            await this.$router.push('/user/login')
        }

    }
}
</script>

<style scoped>
.copyThis { cursor: pointer }
</style>